import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  acceptAltDate,
  addToJourney,
  getOrderInfo,
  getRequestInfo,
} from "../../../../utilities";
import { useNavigate } from "react-router-dom";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import NumbersIcon from "@mui/icons-material/Numbers";
import WorkIcon from "@mui/icons-material/Work";
import HomeIcon from "@mui/icons-material/Home";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import { Button } from "@mui/material";
import {
  Field,
  RequestActionShell,
  SectionLabel,
} from "../../../../components/WindowDoor/Requests/RequestActionUI";

const iconProps = { fontSize: 16 };

const AcceptAlt = () => {
  const { ref } = useParams();
  const [data, setData] = useState("");
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [requestData, setReqData] = useState("");

  useEffect(() => {
    getOrderInfo(ref, setData);
    getRequestInfo(ref, setReqData);
  }, []);

  return (
    <RequestActionShell
      title={`Accept Alternative Date - ${searchParams.get("date")}`}
      accent="emerald"
      icon={EventAvailableOutlinedIcon}
      id={ref}
      showError={requestData.error}
      footer={
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            acceptAltDate(ref, searchParams.get("date"));
            addToJourney(
              searchParams.get("date").replaceAll("/", "-"),
              requestData.orderID
            );
            navigate("/");
          }}
        >
          Accept
        </Button>
      }
    >
      <SectionLabel>Order details</SectionLabel>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <Field
          icon={<PersonOutlineIcon sx={iconProps} />}
          label="Customer"
          value={data.Customer}
        />
        <Field
          icon={<NumbersIcon sx={iconProps} />}
          label="Order Number"
          value={data.OrderNumber}
        />
        <Field
          icon={<WorkIcon sx={iconProps} />}
          label="Job Ref"
          value={data["Job Ref"]}
        />
        <div className="sm:col-span-3">
          <Field
            icon={<HomeIcon sx={iconProps} />}
            label="Deliver To Address"
            value={data["Deliver To"]}
          />
        </div>
      </div>
    </RequestActionShell>
  );
};

export default AcceptAlt;
